/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Features_Tab_ParametricInputs */

const en_cad_features_tab_parametric = /** @type {(inputs: Cad_Features_Tab_ParametricInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parametric`)
};

/**
* | output |
* | --- |
* | "Parametric" |
*
* @param {Cad_Features_Tab_ParametricInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_features_tab_parametric = /** @type {((inputs?: Cad_Features_Tab_ParametricInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Features_Tab_ParametricInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_features_tab_parametric(inputs)
});
export { cad_features_tab_parametric as "cad.features.tab_parametric" }